import * as dayjs from 'dayjs';
import { UserInterface } from '@splixer/common';
import { AnyHash, Uuid } from '@hidat/huijs-common';
import { Expose, Transform } from 'class-transformer';
import { dayjsTransformer } from '@hidat/huijs-dates';
/**
 * Player User
 * This is a subset of the full user, as used by the player, vs. an admin....
 */
export class PlayerUser implements UserInterface {
  @Expose({ name: 'id' })
  id: Uuid | undefined = undefined; //guid

  @Expose({ name: 'name' })
  name: string | undefined = undefined;
  @Expose({ name: 'email_address' })
  email: string | undefined = undefined;
  @Expose({ name: 'email_config' })
  emailConfig: AnyHash = {};
  @Expose({ name: 'external_id' })
  externalId: string | undefined = undefined;

  @Expose({ name: 'current_station_id' })
  currentStationId: number | undefined = undefined;
  @Expose({ name: 'status' })
  status = 100;

  @Expose({ name: 'created_at' })
  @Transform(dayjsTransformer, { toClassOnly: true })
  createdAt: dayjs.Dayjs | undefined = undefined;
  @Expose({ name: 'updated_at' })
  @Transform(dayjsTransformer, { toClassOnly: true })
  updatedAt: dayjs.Dayjs | undefined = undefined;
}

/**
 * Simple interface used to send user info to API
 */
export interface UserHash {
  email_address: string;
  name: string;
  send_mail: boolean;
}
